import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/Marquee";
import Problem from "@/components/landing/Problem";
import Product from "@/components/landing/Product";
import Customers from "@/components/landing/Customers";
import ProofNumbers from "@/components/landing/ProofNumbers";
import HowItWorks from "@/components/landing/HowItWorks";
import Autonomy from "@/components/landing/Autonomy";
import Pricing from "@/components/landing/Pricing";
import Simulator from "@/components/landing/Simulator";
import Platform from "@/components/landing/Platform";
import Position from "@/components/landing/Position";
import Thesis from "@/components/landing/Thesis";
import ProofThreshold from "@/components/landing/ProofThreshold";
import PilotCTA from "@/components/landing/PilotCTA";
import InvestorCTA from "@/components/landing/InvestorCTA";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#050505] font-mono text-white antialiased selection:bg-[#00FF41] selection:text-black" data-testid="app-root">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Problem />
        <Product />
        <Customers />
        <ProofNumbers />
        <HowItWorks />
        <Autonomy />
        <Pricing />
        <Simulator />
        <Platform />
        <Position />
        <Thesis />
        <ProofThreshold />
        <PilotCTA />
        <InvestorCTA />
      </main>
      <Footer />
    </div>
  );
}
